module.exports = __webpack_public_path__ + "55514329ba775ffdcd9d221d7b534df3.svg";